'use client'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

import { useLocale } from '@src/i18n/LocaleProvider'
import { cn } from '@src/utils/tailwind'

interface CarouselBottomArrowsProps {
  desktopVisible: boolean
  mobileVisible: boolean
  previousSlide: (args: any) => void
  nextSlide: (args: any) => void
}

export const CarouselBottomArrows = ({
  desktopVisible,
  mobileVisible,
  previousSlide,
  nextSlide,
}: CarouselBottomArrowsProps) => {
  const { t } = useLocale('carousel')
  const commonStyles = [
    'flex items-center justify-center bg-white flex shrink-0 rounded-full size-10 shadow-[0px_1px_3px_0px_#16181940] transition-all hover:bg-bodi-gray-pearl',
  ]

  return (
    <div
      className={cn('mt-4 hidden items-center justify-center gap-2', {
        flex: mobileVisible,
        'lg:flex': desktopVisible,
      })}
    >
      <button onClick={previousSlide} aria-label={t('previous-slide')} className={cn(commonStyles)}>
        <ChevronLeftIcon className="size-6" />
      </button>
      <button onClick={nextSlide} aria-label={t('next-slide')} className={cn(commonStyles)}>
        <ChevronRightIcon className="size-6" />
      </button>
    </div>
  )
}
